import { useAuthStore } from '@shared/state';
import { PublicHeader } from './headers/PublicHeader';
import { AuthenticatedHeader } from './headers/AuthenticatedHeader';

export function Header() {
  const user = useAuthStore((s) => s.user);
  return user ? <AuthenticatedHeader /> : <PublicHeader />;
}
